import { render, staticRenderFns } from "./timedsalegoodsdetail.vue?vue&type=template&id=ffc6894c&scoped=true"
import script from "./timedsalegoodsdetail.vue?vue&type=script&lang=js"
export * from "./timedsalegoodsdetail.vue?vue&type=script&lang=js"
import style0 from "./timedsalegoodsdetail.vue?vue&type=style&index=0&id=ffc6894c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc6894c",
  null
  
)

export default component.exports